import { ReactNode } from 'react';
import ContentCard from '@v2/shared/components/ContentCard';
import { cn } from '@v2/shared/lib/utils';
import { CARD_GAP } from './styles';

export default function SectionCard({ children, className }: { children: ReactNode; className?: string }) {
  return <ContentCard className={cn(CARD_GAP, className)}>{children}</ContentCard>;
}
